export enum EraserType {
  ORIGINAL = 'original',
  FILL = 'fill',
}
